import "./Login.scss";

import { useEffect, useState } from "react";
import { login, requestResetPassword } from "../../services/auth";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { getCurrentUser } from "../../services/userService";
import { useTranslation } from "react-i18next";

export default function Login({ setOpenLogin, setOpenRegister, setUser }) {
  const { t } = useTranslation();
  const [cookie, setCookie, removeCookie] = useCookies(["access_token"]);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [response, setResponse] = useState();
  const [emptyEmail, setEmptyEmail] = useState(false);
  const [emailNotFound, setEmailNotFound] = useState(false);
  const [emptyPassword, setEmptyPassword] = useState(false);
  const [incorrectPassword, setIncorrectPassword] = useState(false);
  const [isClickedForgotten, setIsClickedForgotten] = useState(false);
  const [isClickedForgottenSuccess, setIsClickedForgottenSuccess] =
    useState("");
  const [forgottenEmail, setForgottenEmail] = useState("");

  const handleLogin = () => {
    if (email === "") {
      setEmptyEmail(true);
    } else {
      emptyEmail && setEmptyEmail(false);
    }

    if (password === "") {
      setEmptyPassword(true);
    } else {
      emptyPassword && setEmptyPassword(false);
    }

    if (emptyEmail && emptyPassword) {
      return;
    }

    login(email, password).then((res) => setResponse(res));
  };

  const handleForgottenPassword = (e) => {
    e.preventDefault();
    requestResetPassword(forgottenEmail).then((res) => {
      if (res?.status === 201 || res?.status === 200) {
        setIsClickedForgottenSuccess("Success");
      } else {
        setIsClickedForgottenSuccess("Fail");
      }
    });
  };

  useEffect(() => {
    removeCookie("access_token");
    if (response?.data?.access_token) {
      setCookie("access_token", response?.data?.access_token, { path: "/" });
      setOpenLogin(false);
    }

    if (response?.data?.statusCode === 400) {
      if (
        response?.data?.message === "USER_WITH_THIS_EMAIL_WAS_NOT_FOUND_ERROR"
      ) {
        setEmailNotFound(true);
        setIncorrectPassword(false);
      }

      if (response?.data?.message === "INCORRECT_PASSWORD_ERROR") {
        setEmailNotFound(false);
        setIncorrectPassword(true);
      }
    }
  }, [response]);

  useEffect(() => {
    cookie?.data?.access_token !== undefined &&
      getCurrentUser(cookie.access_token).then((res) => setUser(res));
    cookie?.data?.access_token !== undefined && setOpenLogin(false);
    cookie?.data?.access_token !== undefined && navigate("/");
  }, [cookie]);
  return (
    <div className="login-wrapper">
      <div className="login-popup">
        <div className="image">
          <img
            src="https://alexfish-static.s3.eu-north-1.amazonaws.com/login_sushi.svg"
            alt="Суши"
          />
        </div>
        {!isClickedForgotten ? (
          <div className="form">
            <div className="title">
              <p>{t("log-in")}</p>
            </div>
            <div className="input-fields">
              <div
                className={
                  emailNotFound || emptyEmail ? "email error" : "email"
                }
              >
                <input
                  type="email"
                  placeholder={`${t("email")}`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                ></input>
                {emailNotFound && (
                  <p className="error">{t("email-not-found")}</p>
                )}
                {emptyEmail && <p className="error">{t("required-field")}</p>}
              </div>
              <div
                className={
                  incorrectPassword || emptyPassword
                    ? "password error"
                    : "password"
                }
              >
                <input
                  type="password"
                  placeholder={`${t("password")}`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {incorrectPassword && (
                  <p className="error">{t("incorrect-password")}</p>
                )}
                {emptyPassword && (
                  <p className="error">{t("required-field")}</p>
                )}
              </div>
            </div>
            <div className="forgot-password">
              <a onClick={() => setIsClickedForgotten(true)}>
                {t("forgot-password")}
              </a>
            </div>
            <div className="buttons">
              <div className="login-button">
                <button onClick={handleLogin}>{t("log-in")}</button>
              </div>
              <div className="register-button">
                <button
                  onClick={() => {
                    setOpenLogin(false);
                    setOpenRegister(true);
                  }}
                >
                  {t("register")}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="forgotten-password">
            {isClickedForgottenSuccess !== "Success" ? (
              <>
                <h2 className="title">Забравена парола</h2>
                <div className="subtitle">
                  <p>
                    Въведете имейла, с който сте се регистрирали и ние ще ви
                    изпратим линк, за да смените паролата си
                  </p>
                </div>
                <form onSubmit={handleForgottenPassword}>
                  <div className={"email"}>
                    <input
                      required
                      type="email"
                      placeholder={`${t("email")}`}
                      value={forgottenEmail}
                      onChange={(e) => setForgottenEmail(e.target.value)}
                    ></input>
                    {isClickedForgottenSuccess === "Fail" && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        Не е намерен акаунт с посочения имейл.
                      </p>
                    )}
                  </div>
                  <div className="buttons">
                    <div className="send-button">
                      <button type="submit">{t("send")}</button>
                    </div>
                  </div>
                </form>
              </>
            ) : (
              <>
                <h2 className="title">Моля, проверете електронната си поща!</h2>
              </>
            )}
          </div>
        )}
        <div className="close-button">
          <button
            onClick={() => {
              setOpenLogin(false);
            }}
          ></button>
        </div>
      </div>
    </div>
  );
}
